import * as React from 'react';
export const growthSvg = React.forwardRef(function growthSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.329.237a.347.347 0 0 0-.658 0L10 2.25l-1.757.44a.32.32 0 0 0 0 .62L10 3.75l.67 2.013a.347.347 0 0 0 .659 0L12 3.75l1.758-.44a.32.32 0 0 0 0-.62L12 2.25 11.329.237ZM14.5 9a1.5 1.5 0 1 0-1.29-.735l-2.5 3.75a1.504 1.504 0 0 0-.86.133L6.962 9.837a1.5 1.5 0 1 0-2.814.313l-2.31 2.888a1.5 1.5 0 1 0 1.015.812l2.31-2.888a1.504 1.504 0 0 0 .987-.11l2.888 2.31a1.5 1.5 0 1 0 2.753-.427l2.5-3.75c.068.01.138.015.209.015ZM3.335 3.119a.173.173 0 0 1 .33 0l.296.996.918.23a.16.16 0 0 1 0 .31l-.883.221a1.502 1.502 0 0 1-.03.098l-.302.907a.173.173 0 0 1-.329 0l-.302-.907a1.507 1.507 0 0 1-.03-.098l-.882-.22a.16.16 0 0 1 0-.311l.883-.221.331-1.005Z',
    }),
  );
});
growthSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var growth = {
  category: 'icon',
  colorable: true,
  name: 'growth',
  svg: growthSvg,
};
